export const INCOME_RECIEVED = "INCOME_RECIEVED"
export const INCOME_SAVED = "INCOME_SAVED"
export const INCOME_DELETED = "INCOME_DELETED"
export const INCOME_UNLOADED = "INCOME_UNLOADED"
